import {ElementType} from './element-type.enum';
import {GenericField} from './GenericFields';
export class Element
{
    id:number;
    elementType:ElementType;
    label:string;
    imageUrl: string;
    displayName:string;
    defaultValue:any;
    genericField:GenericField;
    heading_level:string;
    listItems:any;
    dropdownList:any;
    repeatedList:any;
    isTextHide:boolean;
    is_required:boolean;
    is_read_only:boolean;
    is_hidden_field:boolean;
    fontSize:number;
    fontColor:string;
    fontStyle:string;
    bold:string;
    textAlign:string;
    icon:string;
    infoImage:string;
    infoText:string;
    columnWidth:string;
    fieldWidth:string;
    cssClass:string;
    inline:boolean;
    isAccordion:boolean;
    is_vertical:boolean;
    multiselect_option:string;    
    isDropdown:boolean;
    isCheckBox:boolean;
    labelAlign:string;
    name:string;
    isAccordionHideAll:boolean;
    buttonAction:string;
    isTextArea:boolean;
}